var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"SidebarToggle"}},[_c('span',[_vm._v("Consentua Info ")]),_c('el-switch',{model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }